import React from "react";
import s from "./style.module.css";

export default function PageInexistante() {
  return (
    <div
      className={`${s.pageNotFound} d-flex align-items-center justify-content-center`}
    >
      Page introuvable
    </div>
  );
}
